<div *ngIf="monitorowanieForm" [formGroup]="monitorowanieForm">
  <div *ngIf="przedlozORok" class="container">
    <div class="p-grid w-100">
      <div class="p-col-12">
        <ds-checkbox formControlName="przedlozORok" [label]="'przedlozORok' | transloco"></ds-checkbox>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="p-grid w-100">
      <div class="p-col-6">
        <ds-calendar  formControlName="subskrypcjaOd" [disabled]="disableDataOd" [label]="'rozpoczecieMonitorowania' | transloco" [todayButtonStyleClass]="'button-hidden'" dataType="string" iconRight="pi-calendar" [minDate]="minDate" [maxDate]="maxDate"></ds-calendar>
      </div>
      <div class="p-col-6">
        <ds-calendar  formControlName="subskrypcjaDo" [disabled]="disableDataDo" [label]="'zakonczenieMonitorowania' | transloco" [todayButtonStyleClass]="'button-hidden'" dataType="string" iconRight="pi-calendar" [minDate]="minDateTo" [maxDate]="maxDateTo" [defaultDate]="minDateTo"></ds-calendar>
      </div>
    </div>
  </div>
  <app-instrukcja *ngIf="przedlozORok" [showHeading]="false" [note]="'Monitorowanie zostanie przedłużone o rok. Wcześniejsze dane są dalej dostępne do podglądu'"></app-instrukcja>
  <div class="container p-mt-2">
    <div class="p-grid w-100">
      <div class="p-col-12">
        <ds-checkbox formControlName="powiadomienieEmail" [label]="'wyslaniePowiadomienOZmianachNaEmail' | transloco"></ds-checkbox>
      </div>
    </div>
  </div>
</div>

<ds-loader *ngIf="!monitorowanieForm"></ds-loader>
